<template>
  <div class="spellchecker-buttons__wrapper">
    <aha-button
      :variant="'base'"
      @click.stop="onAcceptButtonClicked"
      @keyup.enter.stop="onAcceptButtonClicked"
      tabindex="0"
      name="spellchecker-accept-button"
      v-aha-emit-action
    >
      {{ $i18nPresenter.t('Accept') }}
    </aha-button>
    <aha-button-link
      :variant="'base'"
      class="pt-0.25"
      @click.stop="onDismissButtonClicked"
      @keyup.enter.stop="onDismissButtonClicked"
      tabindex="0"
      name="spellchecker-dismiss-button"
      v-aha-emit-action
    >
      {{ $i18nPresenter.t('Dismiss') }}
    </aha-button-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    misspell: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    ...mapGetters(['presentationId']),
  },

  methods: {
    ...mapActions('spellchecker', ['acceptMisspellAction', 'dismissMisspellAction']),

    onAcceptButtonClicked() {
      this.acceptMisspellAction({ misspell: this.misspell })
    },

    onDismissButtonClicked() {
      this.dismissMisspellAction({
        presentationId: this.presentationId,
        misspell: this.misspell,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.spellchecker-buttons__wrapper {
  @apply flex gap-4 items-center;
  @apply py-4;
}
</style>
